/**
 * What the buyer reads under a note field (KP-4572): where their words are.
 * Kept quiet on purpose; nothing here asks for attention.
 */

const LABELS = Object.freeze({
  saving: 'Saving',
  saved: 'Saved',
  local: 'Saved on this device only',
  offline: 'Saved on this device only',
})

export const saveStatusLabel = status => LABELS[status] || ''
